module.exports = __webpack_public_path__ + "assets/b988e19da6f3b94aadc61eb2052edae3.svg";